import $ from 'jquery';
import 'lazyload';
import { Fancybox } from '@fancyapps/ui';
import Swiper, {
  Navigation,
  Pagination,
  Autoplay,
  EffectFade,
  Thumbs,
} from 'swiper';
import './cart';
import './form';
import './product';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);

const logo = $('input[name="logo-hidden"]').val();
const logoSmall = $('input[name="logo-small-hidden"]').val();

const onChangeLogo = (value) => {
  $('.header-logo img').attr('src', value);
};

const onSetHeightSlider = () => {
  const heightMageMenu = $('#mega-menu-home').height();
  if (heightMageMenu > 200) {
    $('.swiper-home__items').height(heightMageMenu);
    $('.swiper-home__items').css('padding-top', 0);
  } else {
    $('.swiper-home__items').css('height', '43%');
    $('.swiper-home__items').css('padding-top', '43%');
  }
};

const onSetHeightBanner = () => {
  const heightMageMenu = $('.swiper-home').height();
  $('.banner-right').height(heightMageMenu / 2);
};

onSetHeightSlider();

const width = $(window).width();
if (width < 575) {
  onChangeLogo(logoSmall);
} else {
  onChangeLogo(logo);
}

if (width >= 1023) {
  onSetHeightBanner();
}

$(window).resize(function (e) {
  const width = e.target.outerWidth;
  if (width < 575) {
    onChangeLogo(logoSmall);
  } else {
    onChangeLogo(logo);
  }

  onSetHeightSlider();
  if (width >= 1023) {
    onSetHeightBanner();
  }
});

const swiper = new Swiper('.swiper-home', {
  slidesPerView: 1,
  loop: true,
  // effect: 'fade',
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-home-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-home-button-next',
    prevEl: '.swiper-home-button-prev',
  },
});

new Swiper('.swiper-banner', {
  slidesPerView: 1,
  spaceBetween: 10,
  // loop: true,
  pagination: {
    el: '.swiper-pagination-default',
    clickable: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
  },
});

new Swiper('.swiper-banner-two', {
  slidesPerView: 2,
  spaceBetween: 10,
  // loop: true,
  pagination: {
    el: '.swiper-pagination-default',
    clickable: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 2,
    },
  },
});

new Swiper('.swiper-product', {
  slidesPerView: 2,
  spaceBetween: 0,
  // loop: true,
  navigation: {
    nextEl: '.swiper-button-next-default',
    prevEl: '.swiper-button-prev-default',
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 5,
    },
  },
});

const swiperThumbs = new Swiper('.swiper-detail-thumbs', {
  loop: false,
  spaceBetween: 10,
  slidesPerView: 5,
  freeMode: true,
  watchSlidesProgress: true,
});

new Swiper('.swiper-detail-main', {
  loop: false,
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-button-next-thumbs',
    prevEl: '.swiper-button-prev-thumbs',
  },
  thumbs: {
    swiper: swiperThumbs,
  },
});

new Swiper('.swiper-post', {
  slidesPerView: 1,
  spaceBetween: 20,
  breakpoints: {
    640: {
      slidesPerView: 2,
    },
  },
});

new Swiper('.swiper-cate-child', {
  slidesPerView: 3,
  spaceBetween: 0,
  navigation: {
    nextEl: '.swiper-cate-child-button-next',
    prevEl: '.swiper-cate-child-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 5,
    },
    1024: {
      slidesPerView: 8,
    },
    1200: {
      slidesPerView: 10,
    },
  },
});

const headerHeight = $('.menu-header').innerHeight();
const footerHeight = $('.menu-footer').innerHeight();
const subContentHeight = $('.menu-sub-content').innerHeight();
const outMenu = headerHeight + footerHeight + subContentHeight;
$('.menu-content').css('max-height', 'calc(100vh - ' + outMenu + 'px' + ')');

$('.mobile-menu-button').on('click', (e) => {
  e.stopPropagation();
  $('.mobile-menu').toggleClass('display');
  $('.overlay').toggleClass('display');
});

$('.overlay, .menu-close').on('click', (e) => {
  e.stopPropagation();
  $('.mobile-menu').removeClass('display');
  $('.overlay').removeClass('display');
});

$('.menu-mobile-icon').on('click', (e) => {
  e.stopPropagation();
  $('.menu-mobile-wrapper').toggleClass('open');
});
$('.mask-layout').on('click', (e) => {
  e.stopPropagation();
  $('.menu-mobile-wrapper').removeClass('open');
});

$('.menu-toggle').on('click', (e) => {
  e.preventDefault();
  const menuClass = '.mobile-menu .menu-content';
  const { id } = e.target.dataset;
  $(`${menuClass} li[data-id=${id}]`).toggleClass('active');
  if (
    $(`${menuClass} li[data-id=${id}] .menu-toggle[data-id=${id}]`).hasClass(
      'iconfont-angle-up',
    )
  ) {
    $(`${menuClass} li[data-id=${id}] .menu-toggle[data-id=${id}]`).removeClass(
      'iconfont-angle-up',
    );
    $(`${menuClass} li[data-id=${id}] .menu-toggle[data-id=${id}]`).addClass(
      'iconfont-angle-down',
    );
  } else {
    $(`${menuClass} li[data-id=${id}] .menu-toggle[data-id=${id}]`).removeClass(
      'iconfont-angle-down',
    );
    $(`${menuClass} li[data-id=${id}] .menu-toggle[data-id=${id}]`).addClass(
      'iconfont-angle-up',
    );
  }

  $(`${menuClass} ul[data-id=${id}]`).toggleClass('display');
});

lazyload();

Fancybox.bind('.swiper-detail-main-fancy .single-thumbs-item', {
  groupAll: true,
});

const contentHeight = $('#content-view-more').height();
if (contentHeight >= 600) {
  $('#content-view-more').height(600);
  $('.product-read-more').show();
}
$('.product-read-more').on('click', () => {
  $('#content-view-more').height('auto');
  $('.product-read-less').show();
  $('.product-read-more').hide();
});
$('.product-read-less').on('click', () => {
  $('#content-view-more').height(600);
  $('.product-read-more').show();
  $('.product-read-less').hide();
});

$('#decrease').on('click', () => {
  let quantity = $('#quantity').val();
  if (quantity <= 1) {
    quantity = 2;
  }
  $('#quantity').val(Number(quantity) - 1);
});

$('#increase').on('click', () => {
  let quantity = $('#quantity').val();
  if (quantity >= 1000) {
    quantity = 998;
  }

  $('#quantity').val(Number(quantity) + 1);
});

if ($('.ecommerce').has('#counter').length) {
  let count = 5;
  const counter = () => {
    if (count === 0) {
      window.location.href = '/';
      clearInterval(counter);
      count = 0;
    }

    $('#counter').html(count);
    count = Number(count) - 1;
  };
  setInterval(counter, 1000);
  if (!$('.ecommerce').has('#counter')) {
    clearInterval(counter);
  }
}

const shrinkHeader = 200;
$(window).on('scroll', function () {
  const scroll = getCurrentScroll();
  if (scroll >= shrinkHeader) {
    $('.header-middle').addClass('sticky');
  } else {
    $('.header-middle').removeClass('sticky');
  }
});

$('.toggle').on('click', () => {
  $('#toc').slideToggle('slow', function () {
    const icon = $('.toggle i');
    if ($(this).is(':visible')) {
      icon.removeClass('iconfont-angle-down').addClass('iconfont-angle-up');
    } else {
      icon.removeClass('iconfont-angle-up').addClass('iconfont-angle-down');
    }
  });
});

const getCurrentScroll = () => {
  return window.pageYOffset;
};

$(document).click(function () {
  $('#js-header-search').val('');
  $('#js-header-search-show').empty();
});
$('#js-header-search-show, #js-header-form-search').click(function (e) {
  e.stopPropagation();
});
